import { Link, useSearchParams } from "react-router-dom";
import { PagesRoutes } from "@app/router";
import { Button } from "@shared/components";
import { useTranslation } from "@shared/locales";
import { AuthShell } from "./AuthShell";

/**
 * Shown when the backend reports `user.isEmailVerified === false` after login,
 * and unconditionally after register. No session is stored in either case —
 * the backend's `AuthGuard` rejects unverified users on every route that isn't
 * `@NotValidatedEmail()` — so this route stays inside `PublicOnlyRoute`.
 *
 * Copy is a placeholder and the resend action is disabled: verification happens
 * through the signed link the backend emails (`GET auth/verify-signed-email-link`)
 * and there is no resend endpoint on `API_ROUTES.AUTH_USER` yet.
 */
export function VerifyEmailPage() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");

  return (
    <AuthShell
      title={t("auth.verify.title")}
      description={t("auth.verify.description")}
      footer={
        <Link
          to={PagesRoutes.auth.login}
          className="font-medium text-foreground hover:underline"
        >
          {t("auth.verify.backToLogin")}
        </Link>
      }
    >
      <div className="flex flex-col gap-6">
        <div className="rounded-md border border-border bg-muted px-3 py-2.5 text-sm text-muted-foreground">
          {email
            ? t("auth.verify.placeholderWithEmail", { email })
            : t("auth.verify.placeholder")}
        </div>

        {/* Placeholder action — enable once a resend endpoint exists. */}
        <Button variant="outline" className="w-full" disabled>
          {t("auth.verify.resend")}
        </Button>
      </div>
    </AuthShell>
  );
}
